var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP_Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "premiumIcon",
    id: "Menu-Options",
    transform: "translate(-80.000000, -424.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(26.000000, 424.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.3333333,20.8333333 C80.25,20.8333333 78.25,20.5 76.3833333,19.8833333 C75.8,19.7 75.15,19.8333333 74.6833333,20.2833333 L71.0166667,23.95 C66.3,21.55 62.4333333,17.7 60.0333333,12.9833333 L63.7,9.3 C64.1666667,8.85 64.3,8.2 64.1166667,7.61666667 C63.5,5.75 63.1666667,3.75 63.1666667,1.66666667 C63.1666667,0.75 62.4166667,0 61.5,0 L55.6666667,0 C54.75,0 54,0.75 54,1.66666667 C54,17.3166667 66.6833333,30 82.3333333,30 C83.25,30 84,29.25 84,28.3333333 L84,22.5 C84,21.5833333 83.25,20.8333333 82.3333333,20.8333333 Z M69,0 L69,16.6666667 L74,11.6666667 L84,11.6666667 L84,0 L69,0 Z",
    id: "Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone_chat.12f0931b917ed475488cecba500de46b.svg";